<template>
  <section style="min-height: 400px;">
    <b-tabs
      v-if="catalog"
      v-model="activeTab"
      :animated="false"
      class="boarder-tabs"
      destroyOnHide
      multiline
      expanded
    >
      <b-tab-item :label="$t('attributes.detail_info')" :disabled="loading">
        <basic-form :catalog="catalog" @updated="onUpdated" />
      </b-tab-item>

      <b-tab-item :label="$t('attributes.seo')" :disabled="loading">
        <seo-form :catalog="catalog" @updated="onUpdated" />
      </b-tab-item>

      <b-tab-item :label="$t('attributes.catalog_top_ad')" :disabled="loading">
        <top-ad-form :catalog="catalog" @updated="onUpdated" />
      </b-tab-item>

      <b-tab-item
        :label="$t('attributes.catalog_bottom_ad')"
        :disabled="loading"
      >
        <bottom-ad-form :catalog="catalog" @updated="onUpdated" />
      </b-tab-item>

      <b-tab-item :label="$t('attributes.country_flag')" :disabled="loading">
        <countries-form :catalog="catalog" @updated="onUpdated" />
      </b-tab-item>

      <b-tab-item :label="$t('attributes.catalog_section')" :disabled="loading">
        <section-list :catalog="catalog" @updated="onUpdated" />
      </b-tab-item>

      <b-tab-item :label="$t('attributes.traveler_type')" :disabled="loading">
        <traveler-type-list :catalog="catalog" @updated="onUpdated" />
      </b-tab-item>
    </b-tabs>
  </section>
</template>

<script>
import { CATALOG_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import BasicForm from './BasicForm'
import SeoForm from './SeoForm'
import TopAdForm from './TopAdForm'
import BottomAdForm from './BottomAdForm'
import CountriesForm from './CountriesForm'
import SectionList from './SectionList'
import TravelerTypeList from '@/components/catalogs/TravelerTypeList'

export default {
  name: 'CatalogItem',
  components: {
    BasicForm,
    SeoForm,
    TopAdForm,
    BottomAdForm,
    CountriesForm,
    SectionList,
    TravelerTypeList
  },

  props: {
    catalog_no: {
      required: true,
      type: String
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeTab: 0,
      catalog: null
    }
  },
  watch: {
    catalog_no(catalog_no) {
      this.loadAsync(catalog_no)
    }
  },
  mounted() {
    this.loadAsync(this.catalog_no)
  },
  methods: {
    async loadAsync(catalog_no) {
      try {
        this.$emit('update:loading', true)

        const res = await this.axios.get(`${CATALOG_API}/${catalog_no}`)
        this.catalog = res.data.data
      } catch (e) {
        this.catalog = null

        notifyService.fetch_error('catalog', e)
      } finally {
        this.$emit('update:loading', false)
      }
    },
    onUpdated(catalog) {
      this.catalog = catalog

      this.$emit('updated', catalog)
    }
  }
}
</script>
